import { BookOpen, Code2, FileText, Image as ImageIcon } from 'lucide-react';
import { LogoMark } from './LogoMark';

const suggestions = [
  { title: 'Jelaskan sebuah konsep', short: 'Jelaskan konsep', description: 'Buat penjelasan bertahap yang mudah dipahami.', icon: BookOpen },
  { title: 'Bantu menulis kode', short: 'Bantu menulis kode', description: 'Tinjau, debug, atau buat solusi teknis.', icon: Code2 },
  { title: 'Ringkas dan terjemahkan', short: 'Ringkas teks', description: 'Ubah teks panjang menjadi poin penting.', icon: FileText },
  { title: 'Analisis gambar', short: 'Analisis gambar', description: 'Lampirkan gambar untuk OCR atau pemahaman visual.', icon: ImageIcon },
];

export function EmptyState({ onSuggestion }: { onSuggestion: (value: string) => void }) {
  return (
    <div className="mx-auto flex w-full max-w-[760px] flex-1 flex-col items-center px-3 pt-12 text-center sm:justify-center sm:pb-32 sm:pt-8">
      <LogoMark size="lg" sparkle />
      <h2 className="mt-7 text-3xl font-semibold tracking-[-0.025em] text-primary max-sm:max-w-[330px] max-sm:text-[28px] max-sm:leading-8">
        Apa yang ingin kamu kerjakan?
      </h2>
      <p className="mt-3 max-w-[620px] text-base text-secondary max-sm:text-sm max-sm:leading-5">
        Pilih model terbaik, tulis pertanyaan, atau lampirkan gambar untuk dianalisis.
      </p>
      <div className="mt-8 grid w-full grid-cols-2 gap-3 max-sm:mt-8 max-sm:gap-3">
        {suggestions.map(({ title, short, description, icon: Icon }) => (
          <button
            type="button"
            key={title}
            onClick={() => onSuggestion(title)}
            className="interactive min-h-[74px] rounded-xl border border-border bg-surface-raised p-4 text-left hover:border-accent/50 hover:bg-surface-hover max-sm:min-h-[52px] max-sm:p-3"
          >
            <span className="flex items-center gap-2.5 text-sm font-medium text-primary">
              <span className="grid size-6 shrink-0 place-items-center rounded-md bg-accent-soft text-accent-hover"><Icon className="size-4" /></span>
              <span className="truncate sm:hidden">{short}</span>
              <span className="hidden sm:inline">{title}</span>
            </span>
            <span className="mt-2 block text-sm leading-5 text-muted max-sm:hidden">{description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
